class Serialize {
  /**
   * parse number to currency
   * @param {Number} currency 
   * @param {Number} unit 
   */
  parseCurrency(currency, unit, lng, round = 'ceil') {
    let data = currency / 10.0
    data = Math[round](data)

    const c = this.toLocaleString(data, lng)

    return c
  }

  /**
   * parse number to phone number
   * @param {Number} number 
   * @param {String} countryCode 
   */
  parsePhone(number, countryCode = "+98") {
    return countryCode + " " + number
  }
 
  /**
   * Translate numbers to local mode
   * @param {Number} val value to parse
   * @param {any} params additional params
   */
  toLocaleString(val = '', ...params) {
    if (!val) return '0'.toLocaleString(...params);

    return val.toLocaleString(...params);
  }
 }
 
 export default new Serialize()
